// Routes
export const SCI_HOME_ROUTE = '/';
export const SCI_VEHICLE_ROUTE = '/vehicle';
export const SCI_SERVICES_ROUTE = '/services';
export const SCI_EDIT_SERVICES_ROUTE = '/editServices';
export const SCI_ADVISOR_ROUTE = '/advisor';
export const SCI_SIGNATURE_ROUTE = '/signature';
export const SCI_CONFIRMATION_ROUTE = '/confirmation';
export const SCI_ERROR_ROUTE = '/selfCheckInError';

const CALL = 'CALL';
const TEXT = 'TEXT';
const IN_WAITING_AREA = 'IN_WAITING_AREA';
const IN_WAITING_AREA_ON_TRANSPORT = 'IN_WAITING_AREA_ON_TRANSPORT';
const IN_WAITING_AREA_ON_SERVICES = 'IN_WAITING_AREA_ON_SERVICES';
const NONE = 'NONE';

export const WAITING_OPTIONS = Object.freeze({
  CALL,
  TEXT,
  IN_WAITING_AREA,
  IN_WAITING_AREA_ON_TRANSPORT,
  IN_WAITING_AREA_ON_SERVICES,
  NONE
});

export const WAITING_OPTIONS_SWITCH_CONST = Object.freeze({
  CONTACT_ME: 'contactMe',
  FINDE_ME: 'findMe',
  NO_NEED: 'noNeed'
});

export const ATTENDANCE_STATUS = Object.freeze({
  WITH_ADVISOR: 'WITH_ADVISOR',
  WORKING: 'WORKING',
  NOT_ARRIVED: 'NOT_ARRIVED',
  PAUSED: 'PAUSED',
  UNKNOWN: 'UNKNOWN',
  REVIEWED: 'REVIEWED',
  AT_DEALER: 'AT_DEALER',
  ARRIVED: 'ARRIVED',
  NEVER_ARRIVED: 'NEVER_ARRIVED',
  COMPLETED: 'COMPLETED',
  CHECKED_IN: 'CHECKED_IN',
  PENDING_CUSTOMER_AUTORIZATION: 'PENDING_CUSTOMER_AUTORIZATION',
  VEHICLE_HORS_ROUTE: 'VEHICLE_HORS_ROUTE'
});

export const LIFECYCLE_STATUS = Object.freeze({
  CONFIRMED: 'CONFIRMED',
  CANCELLED: 'CANCELLED'
});

export const SELF_CHECK_IN_FLOW = Object.freeze({
  GENERIC_FLOW: 'GENERIC_FLOW',
  NON_OPERATING_HOURS_CHECK_IN: 'NON_OPERATING_HOURS_CHECK_IN',
  NON_OPERATING_HOURS_ADDITIONAL_SERVICE_CHECK_IN:
    'NON_OPERATING_HOURS_ADDITIONAL_SERVICE_CHECK_IN'
});

export const CHECKED_IN = ATTENDANCE_STATUS.CHECKED_IN;

export const VALID_STATUSES_ARRAY = [
  ATTENDANCE_STATUS.UNKNOWN,
  ATTENDANCE_STATUS.NOT_ARRIVED,
  ATTENDANCE_STATUS.PAUSED,
  ATTENDANCE_STATUS.AT_DEALER,
  ATTENDANCE_STATUS.WITH_ADVISOR
];

export const IN_PROGRESS_STATUSES_ARRAY = [
  ATTENDANCE_STATUS.CHECKED_IN,
  ATTENDANCE_STATUS.ARRIVED,
  ATTENDANCE_STATUS.NEVER_ARRIVED,
  ATTENDANCE_STATUS.PENDING_CUSTOMER_AUTORIZATION,
  ATTENDANCE_STATUS.WORKING,
  ATTENDANCE_STATUS.REVIEWED,
  ATTENDANCE_STATUS.COMPLETED
];

export const APP_NAME = 'Self Check-in';

export const ERROR_TYPE = Object.freeze({
  TOO_EARLY: 'TOO_EARLY',
  ALREADY_BEEN_SCI: 'ALREADY_BEEN_SCI',
  ALREADY_IN_PROGRESS: 'ALREADY_IN_PROGRESS',
  INVALID_LINK: 'INVALID_LINK',
  CANCELLED_OR_PAST: 'CANCELLED_OR_PAST',
  NOT_AVAILABLE: 'NOT_AVAILABLE'
});

export const SCI_PAGE_NAME_BY_ROUTE = Object.freeze({
  [SCI_HOME_ROUTE]: 'Landing Page',
  [SCI_VEHICLE_ROUTE]: 'Vehicle Page',
  [SCI_SERVICES_ROUTE]: 'Review Services Page',
  [SCI_EDIT_SERVICES_ROUTE]: 'Edit Services Page',
  [SCI_ADVISOR_ROUTE]: 'Speak to Advisor Page',
  [SCI_SIGNATURE_ROUTE]: 'Signature Page',
  [SCI_CONFIRMATION_ROUTE]: 'Confirmation Page',
  [SCI_ERROR_ROUTE]: 'Error Page'
});

export const tooEarlyErrorInfo = Object.freeze({
  mainErrorMessageId: 'c8.self.check.in.error.page.too.early',
  mainErrorMessageDefault: 'Too early',
  errorMessageId:
    'c8.self.check.in.error.page.you.can.only.check.in.on.the.day.of.your.appointment',
  errorMessageDefault:
    'You can only check in on the day of <br />  your appointment'
});

export const notAvailableErrorInfo = Object.freeze({
  mainErrorMessageId: 'c8.self.check.in.error.page.not.available',
  mainErrorMessageDefault: 'Not Available',
  errorMessageId: 'c8.self.check.in.error.page.check.in.currently.unavailable',
  errorMessageDefault:
    'Check in is currently unavailable... <br /> Please refresh the page or speak with a <br /> Service Advisor.'
});

export const noAppointmentErrorInfo = Object.freeze({
  mainErrorMessageId: 'c8.self.check.in.error.page.no.appointment',
  mainErrorMessageDefault: 'No Appointment',
  errorMessageId:
    'c8.self.check.in.error.page.check.in.appointment.was.cancelled.or.passed',
  errorMessageDefault:
    'The appointment was either <br /> cancelled or has already passed.'
});

export const inProgressErrorInfo = Object.freeze({
  mainErrorMessageId: 'c8.self.check.in.error.page.already.checked.in',
  mainErrorMessageDefault: 'Already Checked In',
  errorMessageId:
    'c8.self.check.in.error.page.your.appointment.is.already.in.progress',
  errorMessageDefault:
    'Looks like your appointment is <br /> already in progress. If this is an error, <br /> please speak with a Service Advisor.'
});

export const getCarColors = intl => [
  {
    color: '#000000',
    text: intl.formatMessage({ id: 'c8.common.black' }),
    value: 'BLACK'
  },
  {
    color: '#114eab',
    text: intl.formatMessage({ id: 'c8.common.blue' }),
    value: 'BLUE'
  },
  {
    color: '#783300',
    text: intl.formatMessage({ id: 'c8.common.brown' }),
    value: 'BROWN'
  },
  {
    color: '#808080',
    text: intl.formatMessage({ id: 'c8.common.gray' }),
    value: 'GRAY'
  },
  {
    color: '#b89f16',
    text: intl.formatMessage({ id: 'c8.common.gold' }),
    value: 'GOLD'
  },
  {
    color: '#279624',
    text: intl.formatMessage({ id: 'c8.common.green' }),
    value: 'GREEN'
  },
  {
    color: '#d76d17',
    text: intl.formatMessage({ id: 'c8.common.orange' }),
    value: 'ORANGE'
  },
  {
    color: '#3f0c95',
    text: intl.formatMessage({ id: 'c8.common.purple' }),
    value: 'PURPLE'
  },
  {
    color: '#a60000',
    text: intl.formatMessage({ id: 'c8.common.red' }),
    value: 'RED'
  },
  {
    color: '#c4c2c1',
    text: intl.formatMessage({ id: 'c8.common.silver' }),
    value: 'SILVER'
  },
  {
    color: '#ffffff',
    text: intl.formatMessage({ id: 'c8.common.white' }),
    value: 'WHITE'
  },
  {
    color: '#eeee00',
    text: intl.formatMessage({ id: 'c8.common.yellow' }),
    value: 'YELLOW'
  },
  {
    color: 'transparent',
    text: intl.formatMessage({ id: 'c8.common.other' }),
    value: 'OTHER'
  }
];

// @todo: remove when backend sends correct serviceList
export const getAdditionalSelfCheckInServices = intl => [
  intl.formatMessage({
    id: 'c8.self.check.in.config.add.service.1',
    defaultMessage: 'Oil & Filter Change'
  }),
  intl.formatMessage({
    id: 'c8.self.check.in.config.add.service.2',
    defaultMessage: 'Oil Leaks'
  }),
  intl.formatMessage({
    id: 'c8.self.check.in.config.add.service.3',
    defaultMessage: 'Service S/C'
  }),
  intl.formatMessage({
    id: 'c8.self.check.in.config.add.service.4',
    defaultMessage: 'Service Brakes'
  }),
  intl.formatMessage({
    id: 'c8.self.check.in.config.add.service.5',
    defaultMessage: 'State Inspection'
  }),
  intl.formatMessage({
    id: 'c8.self.check.in.config.add.service.6',
    defaultMessage: 'Tire Alignment'
  }),
  intl.formatMessage({
    id: 'c8.self.check.in.config.add.service.7',
    defaultMessage: 'Tire Rotation'
  }),
  intl.formatMessage({
    id: 'c8.self.check.in.config.add.service.8',
    defaultMessage: 'Tire Replacement'
  }),
  intl.formatMessage({
    id: 'c8.self.check.in.config.add.service.9',
    defaultMessage: 'Transmission Service'
  })
];



// WEBPACK FOOTER //
// ./src/constants/selfCheckIn.js